var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    "aria-labelledby": titleId,
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "alarmTitle"
  }, "Alarm") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "alarmTitle"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,5 C28.2842712,5 35,11.7157288 35,20 C35,28.2842712 28.2842712,35 20,35 C11.7157288,35 5,28.2842712 5,20 C5,11.7157288 11.7157288,5 20,5 Z M20,7 C12.8202983,7 7,12.8202983 7,20 C7,27.1797017 12.8202983,33 20,33 C27.1797017,33 33,27.1797017 33,20 C33,12.8202983 27.1797017,7 20,7 Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,0 C8.954305,0 0,8.954305 0,20 C0,31.045695 8.954305,40 20,40 C31.045695,40 40,31.045695 40,20 C40,8.954305 31.045695,0 20,0 Z M20,5 C28.2842712,5 35,11.7157288 35,20 C35,28.2842712 28.2842712,35 20,35 C11.7157288,35 5,28.2842712 5,20 C5,11.7157288 11.7157288,5 20,5 Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9513431,12.9999994 C20.4641634,12.996038 20.8898271,13.3787761 20.9514621,13.8756501 L20.9590975,13.9922153 L21.0308182,23.2049604 C21.0351176,23.7572284 20.5909012,24.2084154 20.0386332,24.2127457 C19.5258129,24.2167071 19.1001492,23.8339689 19.0385142,23.337095 L19.0308788,23.2205298 L18.9591581,14.0077847 C18.9548587,13.4555167 19.3990751,13.0043297 19.9513431,12.9999994 Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,25 C20.5522847,25 21,25.4477153 21,26 C21,26.5522847 20.5522847,27 20,27 C19.4477153,27 19,26.5522847 19,26 C19,25.4477153 19.4477153,25 20,25 Z",
    fill: "#292929"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm);
export default __webpack_public_path__ + "static/media/alarm.69715286cc5ac36b786c162c15115e53.svg";
export { ForwardRef as ReactComponent };